/**
=========================================================
* Argon Dashboard 2 MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-material-ui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
 


import Card from "@mui/material/Card";

// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";


// Argon Dashboard 2 MUI examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Table from "examples/Tables/Table";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import breakpoints from "assets/theme/base/breakpoints";

import { Badge } from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";


// Data
// import authorsTableData from "layouts/tables/data/authorsTableData";
//import ParentsTableData from "Views/people/parents/data/parentsTableData";
import projectsTableData from "layouts/tables/data/projectsTableData";
// import ClassMgtTableData from "Views/Activities/ClassMgt/data/classMgtTableData";

import tutorsParollTableData from "Views/Activities/TutorsPayroll/data/tutorsPayrollTableData"

// import supportTicketTableData from "Views/Activities/SupportTicket/data/supportTicketTableData";
import { useState,useEffect } from "react";
import ApnaTabs from "components/ApnaTabs/ApnaTabs";
 import { Checkbox, FormControlLabel } from "@mui/material";
import DeleteDialog from "components/DeleteDialog/DeleteDialog";

function Tables() {
  const [dialog, setDeleteDialog] = useState(false);
  const handleDeleteClick = () => {
    setDeleteDialog(true);
  };
  const handleClose = ()=>{
    setDeleteDialog(false);
  }
  const { columns, rows } = tutorsParollTableData(handleDeleteClick);

      const tabsData = [
      {label:"All",count:12,color:"#2027e1ff",content:""},
      {label:"Hold",count:5,color:"#ec3c10ff",content:""},
      {label:"Active",count:8,color:"#ec10c7ff",content:""},
      {label:"Completed",count:2,color:"#10a6ecff",content:""},
      {label:"Discontinued",count:4,color:"#1a6808b7",content:""},
      {label:"SME",count:4,color:"#1a6808b7",content:""},
      {label:"Combined",count:4,color:"#1a6808b7",content:""},
      {label:"Separate",count:4,color:"#1a6808b7",content:""},
    ]

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <ArgonBox py={3}>
        <ArgonBox mb={3}>
          <Card>
            <ArgonBox  p={3}>
              <ArgonTypography mb={2}  variant="h6" fontWeight="medium" >Tutor Payroll</ArgonTypography>

              <ArgonBox display="flex" alignItems="center" justifyContent="space-between">
              <ArgonBox sx={{height:"36px"}}>
                  <ApnaTabs tabsData={tabsData} />
              </ArgonBox>
              <ArgonBox>
                                <FormControlLabel
                                  label="Due Class"
                                  control={<Checkbox color="primary" />}
                                  sx={{display: "flex", alignItems: "center" }}
                                />
                               
             </ArgonBox>
              </ArgonBox>
             
            </ArgonBox>

            <ArgonBox
              sx={{
                "& .MuiTableRow-root:not(:last-child)": {
                  "& td": {
                    borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                      `${borderWidth[1]} solid ${borderColor}`,
                  },
                },
              }}
            >
              <Table columns={columns} rows={rows} />
            </ArgonBox>
          </Card>
        </ArgonBox>

        <DeleteDialog
          open={dialog}
          onClose={handleClose}
          onConfirm={handleDeleteClick}
          title="Delete Tutor Payroll"
          description="Are you sure you want to delete this tutor payroll record?"
          cancelText="Cancel"
          confirmText="Confirm"
        />
        

      </ArgonBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Tables;
